import { render } from "./CriarColaborador.vue?vue&type=template&id=6cdc6fe5&scoped=true"
import script from "./CriarColaborador.vue?vue&type=script&lang=js"
export * from "./CriarColaborador.vue?vue&type=script&lang=js"

import "./CriarColaborador.vue?vue&type=style&index=0&id=6cdc6fe5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cdc6fe5"]])

export default __exports__